import { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { logo, nav } from '../data/site';

export default function Header() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('#home');
  const navigate = (hash) => { setActive(hash); setOpen(false); };
  return (
    <header className="site-header">
      <div className="container header-inner">
        <a href="#home" onClick={() => navigate('#home')} className="brand" aria-label="Minrose, back to home">
          <img src={logo} alt="Minrose Child Development Center logo" />
        </a>
        <button className="menu-toggle" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} aria-controls="main-navigation" onClick={() => setOpen(!open)}>
          <SafeIcon icon={open ? FiIcons.FiX : FiIcons.FiMenu} />
        </button>
        <nav id="main-navigation" aria-label="Main navigation" className={`main-nav ${open ? 'is-open' : ''}`}>
          {nav.map(([label, hash]) => <a key={hash} href={hash} aria-current={active === hash ? 'page' : undefined} onClick={() => navigate(hash)}>{label}</a>)}
        </nav>
        <a className="button button-dark header-cta" href="#contact">Talk to Us <span aria-hidden="true">→</span></a>
      </div>
    </header>
  );
}